import React from "react";
import { useFormContext } from "react-hook-form";
import { CreateDisbursementFormFields } from "../Hooks/useCreateDisbursementForm";
import BankAccountSelect from "./BankAccountSelect";
import BankAccountEnter from "./EnterBankAccountForm";
import BankAccountRadioGroup from "./BankAccountRadioGroup";
import { useEmployeeProfileQuery } from "Hooks/useEmployeeProfileQueryContext";

const BankAccountFieldContainer = () => {
  const { userDetails } = useEmployeeProfileQuery();
  const { watch } = useFormContext<CreateDisbursementFormFields>();
  if (!userDetails) {
    return null;
  }
  const userBankAccounts = userDetails.employee.userBankAccounts?.items || [];
  const isSelectingAccount =
    watch("bankAccountOptionRadioGroup") === "EXISTING";
  return (
    <>
      {userBankAccounts.length ? <BankAccountRadioGroup /> : null}
      {isSelectingAccount ? <BankAccountSelect /> : <BankAccountEnter />}
    </>
  );
};

export default BankAccountFieldContainer;
